import React, { memo, useEffect, useState } from 'react';
import { ViewCommentMode } from '../../../constant/comment';
import {
  ICommentCardInfo,
  ICommentSideModal,
  ICommentUserInfo,
} from '../../../interfaces/components/comment.interface';
import { ICommentInteract } from '../../../interfaces/hook.interface';
import CommentCardContent from './CommentCardContent';
import CommentCardMenu from './CommentCardMenu';
import CommentCardUser from './CommentCardUser';
import CommentCardVote from './CommentCardVote';

interface ICommentCard extends ICommentInteract {
  userInfo: ICommentUserInfo;
  buttonList?: React.ReactNode | React.ReactNode[];
  badge?: React.ReactNode;
  commentInfo: ICommentCardInfo;
  parentId?: string;
  isPinned?: boolean;
  commentSectionId?: string;
}

const CommentCard = ({
  userInfo,
  buttonList,
  badge,
  commentInfo,
  parentId,
  toast,
  openConfirm,
  isPinned,
  ...interactAction
}: ICommentCard & ICommentSideModal) => {
  const [mode, setModeTo] = useState(ViewCommentMode.View);

  useEffect(() => {
    window.addEventListener('click', () => {
      setModeTo(ViewCommentMode.View);
    });

    return () => {
      window.removeEventListener('click', () => {
        setModeTo(ViewCommentMode.View);
      });
    };
  }, []);

  const commentCardMenu = (
    <CommentCardMenu
      userInfo={userInfo}
      setModeTo={setModeTo}
      parentId={parentId}
      id={commentInfo.id}
      toast={toast}
      openConfirm={openConfirm}
      isPinned={isPinned}
      {...interactAction}
    />
  );

  return (
    <section className="z-20 w-full overflow-hidden">
      <div className="flex items-center justify-between lg:block">
        <CommentCardUser
          userInfo={userInfo}
          commentDate={commentInfo.commentDate}
          badge={badge}
          commentCardMenu={commentCardMenu}
        />
        <div className="lg:hidden">{commentCardMenu}</div>
      </div>

      <div className="my-2 flex items-start justify-between gap-4 lg:gap-0">
        <CommentCardContent
          content={commentInfo.content}
          id={commentInfo.id}
          toast={toast}
          openConfirm={openConfirm}
          mode={mode}
          setModeTo={setModeTo}
          {...interactAction}
        />
      </div>
      <div className="flex items-center justify-between">
        <div>{buttonList && buttonList}</div>
        <CommentCardVote
          id={commentInfo.id}
          votes={commentInfo.votes}
          isUpvoted={commentInfo.isUpvoted}
          toast={toast}
          openConfirm={openConfirm}
          handleVoteGlobal={interactAction.handleVoteGlobal}
        />
      </div>
    </section>
  );
};

export default memo(CommentCard);
